import { FC } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@features/ui';

interface ConfirmClosePopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}
export const ConfirmClosePopup: FC<ConfirmClosePopupProps> = ({
  open,
  onOpenChange,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[500px] max-w-[90vw] mx-auto">
        <DialogHeader className="mb-5">
          <DialogTitle className="text-2xl text-center mb-[23px]">
            Are you sure?
          </DialogTitle>
          <DialogDescription className="text-white text-[16px] text-center">
            This will make the account inactive and unassign from user
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <div className="flex items-center justify-center gap-10">
            <Button
              className={'w-20'}
              size={'sm'}
              onClick={() => {
                onConfirm();
                onOpenChange(false);
              }}
            >
              Yes, Proceed
            </Button>
            <Button
              className={'w-20'}
              size={'sm'}
              variant={'secondary'}
              onClick={() => {
                onOpenChange(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
